module.exports = __webpack_public_path__ + "img/operationaldevelopment_1.63aab064.png";